import CloudNative from './Template'

export default CloudNative
